import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AdminEntryChoice from "../pages/AdminEntryChoice";
import AdminPanel from "../pages/AdminPanel";
import { GetRouterBasename } from "../utils/verifSubdomain";

export default function AdminRoutes({ choiceOnly = false }) {
    const basename = GetRouterBasename()

    return (
        <BrowserRouter basename={basename}>
            <Routes>
                {choiceOnly ? (
                    <Route path="*" element={<AdminEntryChoice />} />
                ) : (
                    <>
                        <Route path="/admin" element={<AdminPanel />} />
                        <Route path="/admin/*" element={<AdminPanel />} />
                        <Route path="*" element={<Navigate to="/admin" replace />} />
                    </>
                )}
            </Routes>
        </BrowserRouter>
    )
}
